export default __webpack_public_path__ + "static/media/BOD Special Meeting 28 May 2021.b8b2e607.pdf";